export default __webpack_public_path__ + "static/media/logo.fb24ee40.png";